import { Dictionary } from "../types/Dictionary";
import { axiosWithAuth, axiosWithoutAuth } from "../utils/customAxios";
const SettingService =
{
    getProductVersion: async (): Promise<string> => {
        const response = await axiosWithoutAuth.get('systemsetting/productversion');
        return response.data.message;
    },
    getRedCactusIsEnabled: async (): Promise<string> => {
        const response = await axiosWithAuth.get('systemsetting/isredcactusenabled');
        return response.data.message;
    },
    fetchInstanceConfigs: async (): Promise<Dictionary<string> | undefined> => {
        const response = await axiosWithoutAuth.get('systemsetting/getInstanceConfigs?settingName=AIServiceModeInEssential');
        return response.data;
    },
    getLargeFileThreashold: async (): Promise<number> => {
        const response = await axiosWithAuth.get('systemsetting/getLargeFileThreashold');
        return response.data.message;
    }
}

export default SettingService;